import React from 'react';
import { EmptyState as StyledEmptyState } from '../Select.styles';
import type { SelectAppearance } from '../Select.types';

interface EmptyStateProps {
  searchTerm?: string;
  empty?: boolean;
  emptyMessage?: string;
  appearance: SelectAppearance;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  searchTerm,
  empty = false,
  emptyMessage = "No hay opciones disponibles",
  appearance,
}) => {
  const message = searchTerm
    ? "No se encontraron opciones"
    : empty
      ? emptyMessage
      : "No hay opciones disponibles";

  return (
    <StyledEmptyState
      $appearance={appearance}
      role="status"
      aria-live="polite"
    >
      {message}
    </StyledEmptyState>
  );
};
